module.exports = __webpack_public_path__ + "img/dayVIP.6843b96.png";